import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  Signal,
  inject,
} from '@angular/core';
import {
  ActionButton,
  ActionButtonBuilder,
  ActionButtonsComponent,
} from '@web/shared/ui';
import { AdminMultimediaLibraryAction } from '../../enums/admin-multimedia-library-action';
import { of } from 'rxjs';

@Component({
  selector: 'app-multimedia-actions',
  imports: [ActionButtonsComponent],
  templateUrl: './multimedia-actions.component.html',
  styleUrl: './multimedia-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultimediaActionsComponent {
  /* prettier-ignore */
  private readonly actionButtonBuilder = inject<ActionButtonBuilder<AdminMultimediaLibraryAction>>(ActionButtonBuilder);

  public readonly uploadVisibility = input<boolean>(false);
  public readonly uploadClickEvent = output();
  public readonly actions = this.actionsSignalSource();

  private actionsSignalSource(): Signal<
    ActionButton<AdminMultimediaLibraryAction>[]
  > {
    return computed(() => [
      this.actionButtonBuilder
        .initCommand(AdminMultimediaLibraryAction.Upload)
        .command(() => this.notifyUploadFileClickEvent())
        .visibility(() => of(this.uploadVisibility()))
        .label('Prześlij pliki')
        .build(),
    ]);
  }

  private notifyUploadFileClickEvent(): void {
    this.uploadClickEvent.emit();
  }
}
